import { UnderwayTimerManager } from './UnderwayTimerManager';
import { DispatchSessionWatcher } from './DispatchSessionWatcher';

// Single entry point mounted at the app shell (PrivateRoutes, behind the
// `feStageAutomation` gate). Headless only: the undo-window timer manager
// plus the dispatch-session watcher. The visible underway rows are now
// rendered inside the shared bulk activities popup (GlobalBulkOperationQueue)
// via AutomationUnderwaySection — there is no separate automation popup.
export const GlobalAutomationUnderway = () => (
  <>
    <UnderwayTimerManager />
    <DispatchSessionWatcher />
  </>
);
